module.exports = __webpack_public_path__ + "img/cat.54b41f66.png";